export const withTruthyZero = <T extends string | number | undefined>(
  value?: T
): value is Exclude<T, undefined> => !!(value || value === 0);
